module.exports = __webpack_public_path__ + "static/project-5a-3619bedbd990bc85ad69392699cf1477.png";